import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchUserAuthanticationWatcher } from "../../store/action/login";
import { getCbpRequestMessageWatcher } from "../../store/action/cbp";
import { saveEdiRequestWatcher, createEdiRequestWatcher } from "../../store/action/cbp";
import { getCbpResponseMessageWatcher } from "../../store/action/cbpres";
import { AddFileRequestRecordWatcher } from "../../store/action/fileRequestRecord";
import { get as _get } from "lodash";
import Dashboard from "./Dashboard";

function mapStateToProps(state, props) {
  return {
    state,
    shipmentID:_get(state,"isf.shipmentID",[]),
    ediRequestList:_get(state,"cbp.cbpRequestData",[]),
    ediResponseList:_get(state,"cbpres.cbpResponseData",[])
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchUserAuthanticationWatcher,
    getCbpRequestMessageWatcher,
    getCbpResponseMessageWatcher,
    AddFileRequestRecordWatcher,
    saveEdiRequestWatcher,
    createEdiRequestWatcher
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
